import { useEffect, useState } from 'react';
import packageJson from '../../package.json';

const CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

export const useVersionCheck = () => {
    const [needsUpdate, setNeedsUpdate] = useState(false);
    const currentVersion = packageJson.version;

    const checkVersion = async () => {
        try {
            // Add timestamp to bypass cache
            const response = await fetch(`/app/version.json?t=${new Date().getTime()}`, {
                cache: 'no-cache',
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache'
                }
            });

            if (response.ok) {
                const data = await response.json();
                const serverVersion = data.version;

                if (serverVersion !== currentVersion) {
                    setNeedsUpdate(true);
                }
            }
        } catch (error) {
            console.error('Error checking version:', error);
        }
    };

    useEffect(() => {
        // Check on mount
        checkVersion();

        // Check periodically
        const interval = setInterval(checkVersion, CHECK_INTERVAL);

        return () => clearInterval(interval);
    }, []);

    const reloadApp = () => {
        window.location.reload();
    };

    return { needsUpdate, currentVersion, reloadApp };
};
